<template>
    <div :class="{ 'card' : !isOnlyContent }">
        <div
            class="card-header"
            :class="{ 'd-none' : isOnlyContent }">
            チャット
        </div>
        <div :class="{ 'card-body' : !isOnlyContent }">
            <div class="chat-room">
                <div class="chat-message">
                    <div
                        v-if="isWaitingScroll"
                        class="d-flex align-items-center justify-content-center p-5">
                        <b-spinner variant="yokumiru-doctor"></b-spinner>
                    </div>
                    <div v-else>
                        <chat
                            :consultation="consultation"
                            :messages="messages"
                            :participants="participants"
                            :images="images"
                            :timezone="timezone"
                            user-type="doctor">
                        </chat>
                    </div>

                    <div class="white mt-2">
                        <div class="invalid-feedback d-block mt-1"
                             v-if="errors.body">
                            {{ errors.body[0] }}
                        </div>
                        <div class="form-group basic-textarea">
                            <textarea
                                v-model="message"
                                @keydown="keydown"
                                rows="3"
                                class="form-control pl-2 my-0"
                                id="chat_message_textarea"
                                :placeholder="chatPlaceholder"/>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
                        <div class="input-group input-chat-wrapper mr-3">
                            <b-form-file
                                v-model="file"
                                ref="fileinput"
                                accept="image/jpeg, image/png, image/gif, application/pdf"
                                placeholder="画像（jpg, png, gif）またはPDFをアップロード"
                                @change="bindSelectedImage"
                                :class="{ 'is-invalid' : errors.file }">
                            </b-form-file>
                            <div class="ml-3">
                                <div v-if="uploadImage.base64 !== null">
                                    <img class="uploadImage" :src="uploadImage.base64">
                                </div>
                            </div>
                        </div>
                        <button
                            class="btn btn-yokumiru-orange float-right vc-send-button"
                            :disabled="message.length === 0 && file === null"
                            @click="send">送信
                        </button>
                    </div>

                    <div class="d-flex justify-content-end">
                        <div class="invalid-feedback d-block mt-1"
                             v-if="errors.file">
                            {{ errors.file[0] }}
                        </div>
                        <div
                            v-if="errors.body"
                            style="width:auto;"
                            class="invalid-feedback d-block mt-2">
                            {{ errors.body[0] }}
                        </div>
                        <div
                            v-if="errors.message"
                            style="width:auto;"
                            class="invalid-feedback d-block mt-2">
                            {{ errors.message[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: {
            consultation: {
                type: Object,
                required: true,
            },
            timezone: {
                type: String,
                required: true,
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            isOnlyContent: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                inProgress: false,
                isWaitingScroll: false,
                message: '',
                userName: '',
                chatId: '',
                keyDownCode: null,
                messages: [],
                participants: [],
                images: [],
                file: null,
                errors: {},
                uploadImage: {
                    name: null,
                    object: null,
                    base64: null,
                },
                userAgent: null,
            }
        },

        computed: {
            chatPlaceholder: function () {
                if (this.userAgent) {
                    if (this.userAgent.search(/macintosh/) > -1) {
                        return 'Command + Enterキーで送信できます'
                    } else if (this.userAgent.search(/windows/) > -1) {
                        return 'Ctrl + Enterキーで送信できます'
                    }
                }

                return 'メッセージを入力'
            },
        },

        created: function () {
            this.getMessages()
            bus.$on('chat-scroll', this.scrollToLatestMessage)
        },

        beforeDestroy: function () {
            bus.$off('chat-scroll')
        },

        mounted: function () {
            window.Echo.private(`consultation.${this.consultation.id}`)
                .listen('MessageSent', () => {
                    this.getMessages()

                    if (this.isActive) {
                        this.readMessages()
                    }
                })
                .listen('ConsultationMessageImageDeleted', () => {
                    this.getMessages()
                })

            this.userAgent = navigator.userAgent.toLowerCase()
            this.initImage()
        },

        methods: {
            /**
             * 最新メッセージまでスクロールする（チャットタブ表示時に呼ばれる）
             * v-chat-scroll は messages の変更を検知してスクロールするため、擬似的に messages の状態を変える
             */
            scrollToLatestMessage: function () {
                if (this.isWaitingScroll) return
                this.isWaitingScroll = true

                const messages = this.messages
                this.messages = []

                setTimeout(() => {
                    this.messages = messages
                    this.isWaitingScroll = false
                }, 100)
            },

            /**
             * チャットメッセージ取得
             */
            getMessages: function () {
                const endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/messages`

                axios.get(endpoint)
                    .then(({data}) => {
                        this.messages = data.data.messages
                        this.participants = data.data.participants
                        this.images = data.data.images

                        const exists = (this.messages && this.messages.length > 0) || (this.images && this.images.length > 0)
                        bus.$emit('update-tab-css', 'chat', exists)
                    })
            },

            /**
             * チャットメッセージ既読化
             */
            readMessages: function () {
                axios.put(`${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/message_read`)
            },

            /**
             * メッセージ入力
             * Ctrl + Enter / Command + Enter の場合のみ送信
             *
             * @param {object} e
             */
            keydown: function (e) {
                if (((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) && e.keyCode === 13) {
                    this.send()
                }
            },

            /**
             * メッセージ送信
             */
            send: async function () {
                if (this.inProgress) return
                this.inProgress = true

                if (this.message === '' && this.file === null) {
                    this.inProgress = false
                    return
                }

                const req = this.prepareRequest()
                const endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/messages`

                await axios.post(endpoint, req.formData, req.config)
                    .then(({data}) => {
                        this.messages = data.data.messages
                        this.images = data.data.images
                        this.errors = {}
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                        }
                    })

                // 入力エリアリセット
                this.message = ''
                this.$refs.fileinput.reset()
                this.initImage()

                // チャットのテキストエリアにfocus
                bus.$emit('focus-chat-send-message')
                this.inProgress = false
            },

            /**
             * メッセージ送信リクエスト準備
             *
             * @return {Object}
             */
            prepareRequest: function () {
                let formData = new FormData()

                if (this.file) {
                    formData.append('file', this.file)
                }
                if (this.message) {
                    formData.append('body', this.message)
                }

                return {
                    formData: formData,
                    config: {
                        headers: {'content-type': 'multipart/form-data'},
                    },
                }
            },

            /**
             * ファイル選択時処理
             *
             * @return {void}
             */
            bindSelectedImage: function(e) {
                const elem = e.target
                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10485760) {
                        this.errors = { file: ['ファイルサイズは10MB以内にしてください。'] }
                        setTimeout(() => this.initImage(), 100)
                        return
                    }

                    this.uploadImage.object = elem.files[0]
                    this.uploadImage.name = this.uploadImage.object.name

                    if (elem.files[0].type !== 'application/pdf') {
                        const fr = new FileReader()
                        fr.onload = () => { this.uploadImage.base64 = fr.result }
                        fr.readAsDataURL(this.uploadImage.object)
                    } else {
                        this.uploadImage.base64 = null
                    }
                } else {
                    this.initImage()
                }
            },

            /**
             * 状態初期化
             */
            initImage: function() {
                this.file = null
                this.uploadImage = {
                    name: null,
                    object: null,
                    base64: null,
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .vc-send-button {
        width: 80px;
    }
</style>

<style lang="scss">
    .is-invalid {
        .custom-file-label {
            border: 1px solid #dc3545;
        }
    }

    .uploadImage {
        width: 100px;
    }

    div.input-chat-wrapper {
        max-width: 380px;

        span.form-file-text {
            color: #495057;
            font-size: 0.75rem;
            line-height: 24px;
        }
    }
</style>
